import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";

const ExternalLink = ({ to, ...rest }: any) => (
  <a href={to} target="_blank" rel="noopener noreferrer" {...rest} />
);

const ArrowRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    style={{ marginLeft: "8px", verticalAlign: "middle" }}
  >
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  </svg>
);

const Job = (props: any) => (
  <div className="openings-item">
    <div className="div-block-55">
      <h3 className="heading-2 white">{props.jobOpening}</h3>
      <p className="p2 white" style={{ padding: "none" }}>
        {props.location}
      </p>
    </div>
    <div className="div-block-56">
      <Button
        spacer={false}
        outerClass="mosano-button-outer"
        buttonClass="button-container-details"
        buttonHref={props.link}
        buttonHrefClass="button-details green w-button"
        buttonLabel={
          <>
            see details
            <ArrowRight />
          </>
        }
        buttonLine="button-box green"
        LinkComponent={
          /^https?:\/\//.test(props.link || "") ? ExternalLink : undefined
        }
      />
    </div>
  </div>
);

export default Job;

Job.propTypes = {
  jobOpening: PropTypes.string,
  location: PropTypes.string,
  link: PropTypes.string,
};
